import React, { useState } from 'react';
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
} from '@nextui-org/react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaCopy } from 'react-icons/fa';
import { AiFillDelete } from 'react-icons/ai';
import { message } from 'antd';

export default function PostDropdown({ deleteItem }) {
  const copypath = () => {
    const postUrl = window.location.href;
    console.log(postUrl);
    navigator.clipboard
      .writeText(postUrl)
      .then(() => {
        message.success('Link copied to clipboard!');
      })
      .catch((err) => {
        message.error('Failed to copy');
        console.log('Error Link copied to clipboard ', err);
      });
  };

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          startContent={<BsThreeDotsVertical size={16} />}
          isIconOnly
          className="flex text-gray-200 bg-transparent border-transparent"
          size="sm"
        ></Button>
      </DropdownTrigger>
      <DropdownMenu variant="flat" aria-label="Dropdown menu with shortcut">
        <DropdownItem
          key="copy"
          onPress={copypath}
          startContent={<FaCopy />}
          classNames="font-poppins"
        >
          Copy link
        </DropdownItem>

        <DropdownItem
          onPress={deleteItem}
          key="delete"
          className="text-danger"
          startContent={<AiFillDelete className="text-red-500" />}
          color="danger"
          classNames="font-poppins"
        >
          Delete
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
